import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { observer, inject } from 'mobx-react'
import EditSubStoDataPopup from '@components/Popup/EditSubStoDataPopup'
import CreateBankSto from '@components/Popup/CreateBankSto'
import {
    Layout,
    PageHeader,
    Row,
    Col,
    Button,
    Form,
    InputNumber,
    Checkbox,
    Radio,
    Icon,
    Table,
    Tooltip,
    Select,
    Collapse,
    Input,
    DatePicker,
    message,
    notification,
    Popconfirm,
    Switch,
    Tag
} from 'antd'

import { tranzila } from '@services/api'
import { downloadStoRows } from '@utils/index'
import { STO_SEARCH_HANDOFF_PREFIX, StoSearchField } from '@utils/stoSearchHandoff'
import StoDetailsModal from './StoDetailsModal'
import { stoFailureText } from '@pages/Tranzila/stoErrors'

import { rtlInputNumber, customForm, terminalRow, firstRow, secondRow, tableClass } from './search-sto-styles.scss'

const { Panel } = Collapse
const { Item: FormItem } = Form
const CheckboxGroup = Checkbox.Group

@inject((store: any) => {
    const { authStore } = store
    return { authStore }
})
@observer
class SearchStoData extends Component<any, any> {
    activeSearchRequest = 0
    isSearchSubmitting = false

    state = {
        searchType: undefined,
        currentSearch: null,
        keywords: null,
        total: 0,
        page: 1,
        data: [],
        error: null,
        loading: false,
        isStoMode: true,
        idType: 'clientId',
        upsStoStatusKey: null,
        inputEditMode: null,
        loadEditMode: false,
        openEditSubModal: false,
        openBySubModal: false,
        editSubParams: {},
        columnWidths: {},
        downloadLoading: false,
        selectedSto: null
    }

    consumeSearchHandoff = () => {
        const { form, history, location } = this.props
        const params = new URLSearchParams(location.search || '')
        const handoffKey = params.get('handoff')

        if (!handoffKey) return

        params.delete('handoff')
        const remainingSearch = params.toString()
        history.replace({
            pathname: location.pathname,
            search: remainingSearch ? `?${remainingSearch}` : ''
        })

        if (handoffKey.indexOf(STO_SEARCH_HANDOFF_PREFIX) !== 0) return

        let storedValue: string | null = null
        try {
            try {
                storedValue = localStorage.getItem(handoffKey)
            } finally {
                localStorage.removeItem(handoffKey)
            }
        } catch (error) {
            return
        }

        if (!storedValue) return

        let field: StoSearchField = 'token'
        let value = storedValue
        try {
            const parsed = JSON.parse(storedValue)
            if (parsed && typeof parsed === 'object' && parsed.field) {
                if (parsed.field !== 'token' && parsed.field !== 'stoId' && parsed.field !== 'clientId') return
                if (parsed.value === null || parsed.value === undefined || parsed.value === '') return
                field = parsed.field
                value = String(parsed.value)
            }
        } catch (error) {
            // Bare strings were used before structured handoffs; keep treating them as tokens.
        }

        if (field === 'stoId') {
            this.setState({ idType: 'stoId' }, () => {
                form.resetFields()
                form.setFieldsValue({ stoId: value })
                this.handleSubmit()
            })
            return
        }

        if (field === 'clientId') {
            this.setState({ idType: 'clientId' }, () => {
                form.resetFields()
                form.setFieldsValue({ clientId: value })
                this.handleSubmit()
            })
            return
        }

        form.setFieldsValue({ token: value })
        this.handleSubmit()
    }

    async componentDidMount() {
        this.resetSearch()

        const savedWidths = localStorage.getItem('searchStoTableWidths')
        if (savedWidths) {
            try {
                this.setState({ columnWidths: JSON.parse(savedWidths) })
            } catch (error) {
                console.error('Не удалось распарсить ширину колонок из localStorage', error)
            }
        }

        this.consumeSearchHandoff()
    }

    componentWillUnmount() {
        this.activeSearchRequest += 1
        this.isSearchSubmitting = false
    }

    changeStoStatus = async record => {
        const { sto_id, sto_status, user_sub_id, terminal_name } = record
        this.setState({ upsStoStatusKey: sto_id })
        // await new Promise(resolve => setTimeout(resolve, 1000))

        try {
            const payload = {
                sto_id,
                terminal_name,
                user_sub_id,
                update_status: sto_status === 'active' ? 'inactive' : 'active'
            }

            // Call API to update status
            await tranzila.updateStoStatus(payload)

            this.setState(prevState => ({
                data: prevState.data.map(item =>
                    item.sto_id === sto_id
                        ? { ...item, sto_status: sto_status === 'active' ? 'inactive' : 'active' }
                        : item
                ),
                upsStoStatusKey: null
            }))
            notification.open({
                message: 'הסטטוס עודכן בהצלחה',
                placement: 'topLeft'
            })
        } catch (error) {
            notification.open({
                message: 'שגיאה בעדכון סטטוס',
                placement: 'topLeft'
            })
            this.setState({ upsStoStatusKey: null })
        }
    }

    handleSubmit = (e?: React.FormEvent<any>) => {
        if (e) e.preventDefault()

        if (this.isSearchSubmitting) return
        this.isSearchSubmitting = true
        const requestId = ++this.activeSearchRequest

        this.props.form.validateFields((err, values) => {
            if (err || requestId !== this.activeSearchRequest) {
                if (requestId === this.activeSearchRequest) {
                    this.isSearchSubmitting = false
                }
                return
            }

            this.setState({ loading: true }, () => {
                if (requestId !== this.activeSearchRequest) return

                tranzila
                    .getStosList(values)
                    .then(({ status, data }) => {
                        if (requestId !== this.activeSearchRequest) return

                        if (status === 200) {
                            this.setState({ data })
                        }
                    })
                    .catch(err => {
                        if (requestId !== this.activeSearchRequest) return

                        console.log(err && err.response ? err.response.data : err)
                        this.setState({ data: [] })
                        // a contract error of the STO endpoint is NOT "not found": the approved manual-check sentence
                        notification.open({
                            message: stoFailureText(err, 'לא נמצאו פרטים'),
                            placement: 'topLeft'
                        })
                    })
                    .then(() => {
                        if (requestId !== this.activeSearchRequest) return

                        this.isSearchSubmitting = false
                        this.setState({ loading: false })
                    })
            })
        })
    }

    switchToInput = flag => {
        const { setFieldsValue } = this.props.form
        this.setState({ inputEditMode: flag })
        setFieldsValue({ userSubId: undefined })
    }

    addStoDataToState = (row_sto_id, user_sub_sto_id) => {
        this.setState(prevState => ({
            data: prevState.data.map(item => (item.sto_id === row_sto_id ? { ...item, user_sub_sto_id } : item)),
            upsStoStatusKey: null
        }))
    }

    editSubId = async record => {
        const { sto_id, terminal_name, sto_status } = record
        const { getFieldValue, setFieldsValue } = this.props.form
        const user_sub_id = getFieldValue('userSubId')

        if (!user_sub_id) {
            this.switchToInput(null)
            return
        }

        this.setState({ loadEditMode: true })

        try {
            const payload = {
                sto_id,
                terminal_name,
                user_sub_id,
                sto_status
            }

            // Call API to update status
            const { status, data } = await tranzila.updateSubscriptionIdSto(payload)

            this.setState(prevState => ({
                data: prevState.data.map(item =>
                    item.sto_id === sto_id ? { ...item, user_sub_id, user_sub_name: data.user_sub_name } : item
                ),
                loadEditMode: false,
                inputEditMode: null
            }))
            notification.open({
                message: 'מספר מנוי עודכן בהצלחה',
                placement: 'topLeft'
            })
            setFieldsValue({ userSubId: undefined })
        } catch (error) {
            notification.open({
                message: 'שגיאה בעדכון מספר מנוי',
                placement: 'topLeft'
            })
            this.setState({ loadEditMode: false, inputEditMode: null })
            setFieldsValue({ userSubId: undefined })
        }
    }

    validateIds = (rule, value, callback) => {
        const { getFieldValue, validateFields } = this.props.form
        const { idType } = this.state
        const stoId = getFieldValue('stoId')
        const clientId = getFieldValue('clientId')
        // prettier-ignore
        const fields = ['clientId', 'token', 'last4Digits', 'accountNumber', 'clientName', 'clientEmail', 'clientIdentity', 'cardHolderIdentity']

        const hasAnyValue = fields.some(field => {
            const value = getFieldValue(field)
            return value && value.toString().trim() !== ''
        })

        if (idType === 'stoId' && !stoId) {
            callback('יש למלא שדה')
        } else if (idType === 'clientId' && !hasAnyValue) {
            callback('יש למלא לפחות שדה אחד')
        } else {
            callback()
        }
    }

    resetColumnWidths = () => {
        this.setState({ columnWidths: {} })
        localStorage.removeItem('searchStoTableWidths')
    }

    resetSearch = () => {
        this.activeSearchRequest += 1
        this.isSearchSubmitting = false

        this.setState({
            searchType: undefined,
            currentSearch: null,
            keywords: null,
            total: 0,
            page: 1,
            data: [],
            error: null,
            loading: false,
            isStoMode: true,
            idType: 'clientId',
            upsStoStatusKey: null,
            inputEditMode: null,
            loadEditMode: false,
            openEditSubModal: false,
            editSubParams: {},
            columnWidths: {},
            openBySubModal: false,
            downloadLoading: false,
            selectedSto: null
        })
        localStorage.removeItem('searchStoTableWidths')
        this.props.form.resetFields()
    }

    downloadStoFile = () => {
        if (!this.state.data || this.state.data.length === 0) {
            notification.open({ message: 'אין נתונים להורדה', placement: 'topLeft' })
            return
        }
        this.setState({ downloadLoading: true })
        tranzila
            .getStoListFile({ rows: this.state.data })
            .then(res => downloadStoRows(res))
            .catch(() => notification.open({ message: 'שגיאת הורדת קובץ', placement: 'topLeft' }))
            .finally(() => this.setState({ downloadLoading: false }))
    }

    handleSwitchChange = value => {
        const { form } = this.props

        this.setState({ idType: value })
        form.resetFields()
    }

    formatDate(dateStr: string, timeStr?: boolean) {
        const date = new Date(dateStr)
        const dateFormatted = date.toLocaleDateString('he-IL')

        if (!timeStr) return dateFormatted

        const timeFormatted = date.toLocaleTimeString('he-IL', {
            hour: '2-digit',
            minute: '2-digit'
        })

        return `${dateFormatted} - ${timeFormatted}`
    }

    validateAmountRange = (rule, value, callback) => {
        const { getFieldValue } = this.props.form
        const from = getFieldValue('chargeAmountFrom')
        const to = getFieldValue('chargeAmountTo')

        if (from && to && from > to) {
            callback('סכום "מ-" חייב להיות קטן מ-"עד-"')
        } else {
            callback()
        }
    }

    ResizeableTitle = props => {
        const { onResize, width, ...restProps } = props

        if (!width) {
            return <th {...restProps} />
        }

        const onMouseDown = e => {
            e.stopPropagation()
            e.preventDefault()

            let startX = e.clientX
            let currentWidth = width

            const onMouseMove = moveEvent => {
                const deltaX = startX - moveEvent.clientX
                currentWidth = currentWidth + deltaX
                startX = moveEvent.clientX
                const newWidth = Math.max(50, currentWidth)
                onResize(moveEvent, { size: { width: newWidth } })
            }

            const onMouseUp = () => {
                document.removeEventListener('mousemove', onMouseMove)
                document.removeEventListener('mouseup', onMouseUp)
            }

            document.addEventListener('mousemove', onMouseMove)
            document.addEventListener('mouseup', onMouseUp)
        }

        return (
            <th {...restProps} className={`${restProps.className || ''} react-resizable`}>
                {restProps.children}
                <span className="react-resizable-handle react-resizable-handle-w" onMouseDown={onMouseDown} />
            </th>
        )
    }

    handleResize = key => (e, { size }) => {
        this.setState(({ columnWidths }) => {
            const nextWidths = {
                ...columnWidths,
                [key]: size.width
            }
            localStorage.setItem('searchStoTableWidths', JSON.stringify(nextWidths))
            return { columnWidths: nextWidths }
        })
    }

    components = () => {
        return {
            header: {
                cell: this.ResizeableTitle
            }
        }
    }

    copyPaymentToken = async (token?: string) => {
        const formattedToken = token ? token.trim() : ''

        if (!formattedToken) {
            message.warning('לא נמצא טוקן להעתקה')
            return
        }

        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(formattedToken)
            } else {
                const textarea = document.createElement('textarea')
                textarea.value = formattedToken
                textarea.style.position = 'fixed'
                textarea.style.left = '-999999px'
                textarea.style.top = '-999999px'

                document.body.appendChild(textarea)
                textarea.focus()
                textarea.select()
                document.execCommand('copy')
                document.body.removeChild(textarea)
            }

            message.success('הטוקן הועתק')
        } catch (err) {
            console.error('Copy token error:', err)
            message.error('לא ניתן להעתיק את הטוקן')
        }
    }

    render() {
        const {
            authStore: { roles }
        } = this.props
        const {
            handleSubmit,
            handleSwitchChange,
            validateIds,
            validateAmountRange,
            resetSearch,
            formatDate,
            changeStoStatus,
            switchToInput,
            editSubId,
            addStoDataToState,
            components,
            resetColumnWidths
        } = this
        const {
            data,
            loading,
            error,
            idType,
            upsStoStatusKey,
            inputEditMode,
            loadEditMode,
            openEditSubModal,
            editSubParams,
            columnWidths,
            openBySubModal,
            downloadLoading,
            selectedSto
        } = this.state
        const { getFieldDecorator } = this.props.form
        const hasAcceptedRole = roles.includes('admin') || roles.includes('money')

        const columns = [
            {
                title: 'מזהה הוראת חיוב',
                key: 'sto_id',
                align: 'center',
                hidden: false,
                width: 150,
                render: (_, record) => {
                    const { sto_id, user_sub_id } = record

                    return (
                        <div className={terminalRow}>
                            <Tooltip placement="top" title={'לא מקושר למנוי'}>
                                <Icon
                                    type="exclamation-circle"
                                    theme="twoTone"
                                    twoToneColor="red"
                                    style={{ cursor: 'pointer', display: user_sub_id ? 'none' : '' }}
                                />
                            </Tooltip>
                            <div>{sto_id}</div>
                            <Tooltip placement="top" title="פרטי הוראת חיוב">
                                <Icon
                                    type="info-circle"
                                    theme="twoTone"
                                    twoToneColor="#1890ff"
                                    style={{ cursor: 'pointer' }}
                                    onClick={event => {
                                        event.stopPropagation()
                                        this.setState({ selectedSto: record })
                                    }}
                                />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'אמצעי תשלום',
                key: 'terminal_name',
                align: 'center',
                hidden: false,
                width: 120,
                render: (_, { terminal_name = '', card = {}, msv = {} }) => {
                    const paymentInfo = terminal_name === 'mediwhobk' ? msv : card
                    // prettier-ignore
                    const { bank_code = '', branch_code = '', account_number = '', expire_month = '', expire_year = '', token = '' } = paymentInfo || {}
                    const isBank = terminal_name === 'mediwhobk'
                    return (
                        <div className={terminalRow}>
                            <Tooltip
                                placement="topRight"
                                title={
                                    <div>
                                        {isBank ? <div>קוד בנק: {bank_code || '-'}</div> : null}
                                        {isBank ? <div>מספר סניף: {branch_code || '-'}</div> : null}
                                        {isBank ? <div>מספר חשבון: {account_number || '-'}</div> : null}
                                        {isBank ? null : (
                                            <div>
                                                תוקף כרטיס: {expire_month}/{expire_year}
                                            </div>
                                        )}
                                        {isBank ? null : (
                                            <div>4 ספ' אחרונות: {token ? token.trim().slice(-4) : '-'}</div>
                                        )}
                                    </div>
                                }
                            >
                                <Icon
                                    type={isBank ? 'bank' : 'credit-card'}
                                    theme="twoTone"
                                    onClick={
                                        !isBank
                                            ? event => {
                                                  event.stopPropagation()
                                                  this.copyPaymentToken(token)
                                              }
                                            : undefined
                                    }
                                    style={{ cursor: 'pointer' }}
                                />
                            </Tooltip>
                            {terminals[terminal_name]}
                        </div>
                    )
                }
            },
            {
                title: 'תאריך חיוב ראשון',
                key: 'first_charge_date',
                align: 'center',
                hidden: false,
                width: 150,
                render: (_, { first_charge_date = '' }) => (first_charge_date ? formatDate(first_charge_date) : '-')
            },
            {
                title: 'תאריך חיוב אחרון',
                key: 'last_charge_date',
                align: 'center',
                hidden: false,
                width: 200,
                render: (_, { last_charge_date = '' }) => (last_charge_date ? formatDate(last_charge_date, true) : '-')
            },
            {
                title: 'תאריך חיוב הבא',
                key: 'next_charge_date',
                align: 'center',
                hidden: false,
                width: 150,
                render: (_, record) => {
                    const { next_charge_date = '', sto_status = '' } = record
                    return next_charge_date && sto_status === 'active' ? formatDate(next_charge_date) : '-'
                }
            },
            {
                title: 'תאריך יצירה',
                key: 'create_date',
                align: 'center',
                hidden: false,
                width: 200,
                render: (_, { create_date = '' }) => (create_date ? formatDate(create_date, true) : '-')
            },
            {
                title: 'סטטוס',
                key: 'sto_status',
                align: 'center',
                hidden: false,
                width: 170,
                render: (_, record) => {
                    const { sto_status = 'error', sto_id, exist_status_conflict, terminal_name } = record
                    const updStatus = upsStoStatusKey === sto_id
                    const showWarn = exist_status_conflict && hasAcceptedRole
                    const disableSwitch = terminal_name === 'mediwhotok' || sto_status === 'error'

                    return (
                        <div style={{ color: statuses[sto_status].color, gap: '4px' }} className={terminalRow}>
                            <Icon
                                type={updStatus ? 'loading' : statuses[sto_status].type}
                                theme={updStatus ? 'outlined' : 'twoTone'}
                                twoToneColor={updStatus ? '' : statuses[sto_status].color}
                            />
                            <div style={{ fontWeight: 'bold' }}>{statuses[sto_status].title}</div>
                            <Popconfirm
                                title="האם לבצע שינוי בסטטוס?"
                                onConfirm={() => changeStoStatus(record)}
                                okText="כן"
                                cancelText="לא"
                            >
                                {disableSwitch ? (
                                    ''
                                ) : (
                                    <Switch checked={sto_status === 'active'} disabled={disableSwitch} />
                                )}
                            </Popconfirm>
                            <Tooltip placement="top" title={'קיימת התנגשות בסטטוס'}>
                                <Icon
                                    type="exclamation-circle"
                                    theme="twoTone"
                                    twoToneColor="red"
                                    style={{ cursor: 'pointer', display: showWarn ? '' : 'none' }}
                                />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'סכום',
                key: 'charge_amount',
                align: 'center',
                hidden: false,
                width: 110,
                render: (_, { charge_amount = '', price_mismatch = false }) => {
                    return (
                        <div className={terminalRow}>
                            <Tooltip placement="top" title={'מחירים אינם תואמים'}>
                                <Icon
                                    type="exclamation-circle"
                                    theme="twoTone"
                                    twoToneColor="red"
                                    style={{ cursor: 'pointer', display: price_mismatch ? '' : 'none' }}
                                />
                            </Tooltip>
                            <div style={{ fontWeight: 'bold' }}>
                                {charge_amount ? charge_amount.split('.')[0] + '₪' : '-'}
                            </div>
                        </div>
                    )
                }
            },
            {
                title: 'שם מנוי',
                key: 'client_sub_name',
                align: 'center',
                hidden: false,
                width: 300,
                render: (_, record) => {
                    const { user_sub_name = '', missing_sku_key = false, sku_mismatch = false } = record
                    const showWarn = (missing_sku_key || sku_mismatch) && hasAcceptedRole
                    const warnText = missing_sku_key ? 'שם המוצר לא קיים ב-Tranzila' : 'שמות המק״טים אינם תואמים'

                    return (
                        <div className={terminalRow}>
                            <Tooltip placement="top" title={warnText}>
                                <Icon
                                    type="exclamation-circle"
                                    theme="twoTone"
                                    twoToneColor="red"
                                    style={{ cursor: 'pointer', display: showWarn ? '' : 'none' }}
                                />
                            </Tooltip>
                            <div style={{ direction: 'ltr' }}>{user_sub_name || '-'}</div>
                        </div>
                    )
                }
            },
            {
                title: 'שם לקוח',
                key: 'client_name',
                align: 'center',
                hidden: false,
                width: 300,
                render: (_, { client = {}, client_user_id, client_user_name = null }) => {
                    const { name = '' } = client || {}
                    const clientName = typeof name === 'string' ? name.trim() : ''

                    if (client_user_id === null) {
                        return (
                            <div>
                                <div>{clientName || '-'}</div>
                                <Tag color="red">שם לקוח לא תקין</Tag>
                            </div>
                        )
                    }

                    if (client_user_id === undefined || String(client_user_id).trim() === '') {
                        return <div>{clientName || '-'}</div>
                    }

                    return (
                        <div>
                            {client_user_name || clientName || '-'}
                            {' - '}
                            <a
                                target={'_blank'}
                                href={`/clients/${client_user_id}`}
                                className={''}
                            >{`${client_user_id}`}</a>
                        </div>
                    )
                }
            },
            {
                title: 'מספר מנוי',
                key: 'user_sub_id',
                align: 'center',
                fixed: 'left',
                width: 150,
                hidden: !hasAcceptedRole,
                render: (_, record) => {
                    const {
                        user_sub_id = '',
                        sto_id = '',
                        total_subs_count: { exist_multiple_conflict }
                    } = record

                    const isEditMode = inputEditMode === sto_id

                    return (
                        <div className={terminalRow}>
                            <Popconfirm
                                title="האם לבצע שינוי במספר מנוי?"
                                onConfirm={() => switchToInput(sto_id)}
                                okText="כן"
                                cancelText="לא"
                            >
                                {hasAcceptedRole ? (
                                    <Icon type="edit" style={{ display: isEditMode ? 'none' : '' }} />
                                ) : null}
                            </Popconfirm>

                            <div style={{ display: isEditMode ? 'flex' : 'none', alignItems: 'center' }}>
                                <Button
                                    onClick={() => switchToInput(null)}
                                    style={{ margin: 'unset' }}
                                    disabled={loadEditMode}
                                >
                                    <Icon type="close" />
                                </Button>
                                {getFieldDecorator('userSubId')(
                                    <InputNumber
                                        placeholder="הקלד מזהה"
                                        className={rtlInputNumber}
                                        style={{ width: '120px', minWidth: '120px' }}
                                        parser={value => value.replace(/[^\d]/g, '')}
                                    />
                                )}
                                <Button
                                    style={{ margin: 'unset' }}
                                    onClick={() => editSubId(record)}
                                    disabled={loadEditMode}
                                >
                                    <Icon type={loadEditMode ? 'loading' : 'save'} />
                                </Button>
                            </div>

                            <div style={{ display: isEditMode ? 'none' : '' }}>{user_sub_id || '-'}</div>
                            <Tooltip placement="top" title={'למשתמש קיימים מספר מנויים במערכת'}>
                                <Icon
                                    type="exclamation-circle"
                                    theme="twoTone"
                                    twoToneColor="red"
                                    style={{ cursor: 'pointer', display: exist_multiple_conflict ? '' : 'none' }}
                                />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'מזהה חיוב קיים במערכת',
                key: 'is_sto_exist',
                align: 'center',
                fixed: 'left',
                width: 150,
                hidden: !hasAcceptedRole,
                render: (_, record) => {
                    const { user_sub_id, user_sub_sto_id } = record
                    const idExist = user_sub_id && user_sub_sto_id
                    const iconBy = idExist ? sto_id_status['exist'] : sto_id_status['notExist']
                    return (
                        <div className={terminalRow}>
                            <Icon type={iconBy.type} theme={'twoTone'} twoToneColor={iconBy.color} />
                            <div style={{ fontWeight: 'bold' }}>{iconBy.title}</div>
                            <Popconfirm
                                title="האם לשמור נתוני חיוב במערכת?"
                                onConfirm={() => this.setState({ openEditSubModal: true, editSubParams: record })}
                                okText="כן"
                                cancelText="לא"
                            >
                                <Icon type="edit" style={{ display: user_sub_id ? '' : 'none' }} />
                            </Popconfirm>
                        </div>
                    )
                }
            }
        ]

        const resizableColumns = columns
            .filter(col => !col.hidden)
            .map(col => ({
                ...col,
                width: columnWidths[col.key] || col.width,
                onHeaderCell: column => ({
                    width: columnWidths[col.key] || column.width,
                    onResize: this.handleResize(col.key)
                })
            }))

        return (
            <Layout>
                <EditSubStoDataPopup
                    visible={openEditSubModal}
                    onClose={() => this.setState({ openEditSubModal: false })}
                    sto_data={editSubParams}
                    addStoDataToState={addStoDataToState}
                />
                <CreateBankSto visible={openBySubModal} onClose={() => this.setState({ openBySubModal: false })} />
                <StoDetailsModal
                    visible={Boolean(selectedSto)}
                    sto={selectedSto}
                    onClose={() => this.setState({ selectedSto: null })}
                />
                <PageHeader
                    onBack={() => window.history.back()}
                    title="ניהול חיובים"
                    extra={[
                        <Button
                            key="1"
                            style={{ position: 'absolute', left: '24px', display: hasAcceptedRole ? '' : 'none' }}
                            onClick={() => this.setState({ openBySubModal: true })}
                        >
                            <Icon type="plus-circle" />
                            <span>הוספת הוראת חיוב</span>
                        </Button>,
                        <Button
                            key="2"
                            style={{ position: 'absolute', left: '200px', display: hasAcceptedRole ? '' : 'none' }}
                            loading={downloadLoading}
                            disabled={downloadLoading || !data || data.length === 0}
                            onClick={this.downloadStoFile}
                        >
                            <Icon type="download" />
                            <span>הורדת קובץ</span>
                        </Button>
                    ]}
                >
                    <Form onSubmit={handleSubmit} layout="vertical" className={customForm}>
                        <Row gutter={24} justify={'start'} type={'flex'} className={firstRow}>
                            <Col span={3}>
                                <FormItem label="סוג מזהה" labelCol={{ style: { textAlign: 'right' } }}>
                                    <Select value={idType} onChange={handleSwitchChange} style={{ width: '100%' }}>
                                        <Select.Option value="clientId">לקוח</Select.Option>
                                        <Select.Option value="stoId">חיוב</Select.Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col span={4}>
                                <FormItem
                                    label={idType === 'stoId' ? 'מזהה חיוב' : 'מזהה לקוח'}
                                    labelCol={{ style: { textAlign: 'right' } }}
                                >
                                    {getFieldDecorator(idType, {
                                        rules: [{ validator: validateIds, required: idType === 'stoId' }]
                                    })(
                                        <InputNumber
                                            placeholder="הקלד מזהה"
                                            className={rtlInputNumber}
                                            parser={value => value.replace(/[^\d]/g, '')}
                                        />
                                    )}
                                </FormItem>
                            </Col>

                            <Col span={3.5}>
                                <FormItem label="מסוף" labelCol={{ style: { textAlign: 'right' } }}>
                                    {getFieldDecorator('terminalName', {
                                        initialValue: terminalOptions.map(opt => opt.value),
                                        rules: [{ required: true, message: 'נא לבחור מסוף' }]
                                    })(<CheckboxGroup options={terminalOptions} />)}
                                </FormItem>
                            </Col>

                            <Col span={7}>
                                <FormItem label="סטטוס" labelCol={{ style: { textAlign: 'right' } }}>
                                    {getFieldDecorator('status', {
                                        initialValue: ''
                                    })(<Radio.Group options={statusOptions} />)}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={24} justify={'start'} type={'flex'} className={secondRow}>
                            <Col span={24}>
                                <Collapse style={{ display: idType === 'stoId' ? 'none' : '' }}>
                                    <Panel header="פרמטרים נוספים לחיפוש" key="1">
                                        <Row gutter={16} justify={'start'} type={'flex'}>
                                            {/* Token */}
                                            <Col span={6}>
                                                <FormItem label="טוקן" labelCol={{ style: { textAlign: 'right' } }}>
                                                    {getFieldDecorator('token', {
                                                        rules: [{ validator: validateIds }]
                                                    })(
                                                        <Input
                                                            style={{
                                                                width: '100%',
                                                                direction: 'rtl',
                                                                textAlign: 'right'
                                                            }}
                                                            placeholder="הזן טוקן"
                                                        />
                                                    )}
                                                </FormItem>
                                            </Col>

                                            {/* Last 4 Digits */}
                                            <Col span={6}>
                                                <FormItem
                                                    label="4 ספרות אחרונות"
                                                    labelCol={{ style: { textAlign: 'right' } }}
                                                >
                                                    {getFieldDecorator('last4Digits', {
                                                        rules: [{ validator: validateIds }]
                                                    })(
                                                        <InputNumber
                                                            maxLength={4}
                                                            placeholder="0000"
                                                            className={rtlInputNumber}
                                                            parser={value => value.replace(/[^\d]/g, '')}
                                                        />
                                                    )}
                                                </FormItem>
                                            </Col>
                                            {/* Last 4 Digits */}
                                            <Col span={6}>
                                                <FormItem
                                                    label="מספר חשבון בנק"
                                                    labelCol={{ style: { textAlign: 'right' } }}
                                                >
                                                    {getFieldDecorator('accountNumber', {
                                                        rules: [{ validator: validateIds }]
                                                    })(
                                                        <InputNumber
                                                            maxLength={12}
                                                            placeholder=""
                                                            className={rtlInputNumber}
                                                            parser={value => value.replace(/[^\d]/g, '')}
                                                        />
                                                    )}
                                                </FormItem>
                                            </Col>
                                            {/* client name */}
                                            <Col span={6}>
                                                <FormItem label="שם לקוח" labelCol={{ style: { textAlign: 'right' } }}>
                                                    {getFieldDecorator('clientName', {
                                                        rules: [{ validator: validateIds }]
                                                    })(
                                                        <Input
                                                            style={{
                                                                width: '100%',
                                                                direction: 'rtl',
                                                                textAlign: 'right'
                                                            }}
                                                            placeholder="הזן שם לקוח"
                                                        />
                                                    )}
                                                </FormItem>
                                            </Col>
                                            {/* client email */}
                                            <Col span={6}>
                                                <FormItem label="דוא״ל" labelCol={{ style: { textAlign: 'right' } }}>
                                                    {getFieldDecorator('clientEmail', {
                                                        rules: [{ validator: validateIds }]
                                                    })(
                                                        <Input
                                                            style={{
                                                                width: '100%',
                                                                direction: 'rtl',
                                                                textAlign: 'right'
                                                            }}
                                                            placeholder="הזן דוא״ל"
                                                        />
                                                    )}
                                                </FormItem>
                                            </Col>
                                            {/* client identity */}
                                            <Col span={6}>
                                                <FormItem label="ת״ז" labelCol={{ style: { textAlign: 'right' } }}>
                                                    {getFieldDecorator('clientIdentity', {
                                                        rules: [{ validator: validateIds }]
                                                    })(
                                                        <InputNumber
                                                            className={rtlInputNumber}
                                                            placeholder="הזן ת״ז"
                                                            maxLength={9}
                                                            parser={value => value.replace(/[^\d]/g, '')}
                                                        />
                                                    )}
                                                </FormItem>
                                            </Col>
                                            {/* cardholder client identity */}
                                            <Col span={6}>
                                                <FormItem
                                                    label="ת״ז בעל הכרטיס"
                                                    labelCol={{ style: { textAlign: 'right' } }}
                                                >
                                                    {getFieldDecorator('cardHolderIdentity', {
                                                        rules: [{ validator: validateIds }]
                                                    })(
                                                        <InputNumber
                                                            className={rtlInputNumber}
                                                            placeholder="הזן ת״ז"
                                                            maxLength={9}
                                                            parser={value => value.replace(/[^\d]/g, '')}
                                                        />
                                                    )}
                                                </FormItem>
                                            </Col>
                                            <Col span={6}>
                                                <FormItem
                                                    label="סכום חיוב"
                                                    labelCol={{ style: { textAlign: 'right' } }}
                                                >
                                                    <Input.Group compact style={{ display: 'flex', direction: 'rtl' }}>
                                                        {getFieldDecorator('chargeAmountFrom', {
                                                            rules: [{ validator: validateAmountRange }]
                                                        })(
                                                            <InputNumber
                                                                placeholder="מ-"
                                                                style={{
                                                                    width: '50%',
                                                                    textAlign: 'right'
                                                                }}
                                                                min={0}
                                                                className={rtlInputNumber}
                                                                parser={value => value.replace(/[^\d]/g, '')}
                                                            />
                                                        )}

                                                        {getFieldDecorator('chargeAmountTo', {
                                                            rules: [{ validator: validateAmountRange }]
                                                        })(
                                                            <InputNumber
                                                                placeholder="עד-"
                                                                style={{
                                                                    width: '50%',
                                                                    textAlign: 'right'
                                                                }}
                                                                min={0}
                                                                className={rtlInputNumber}
                                                                parser={value => value.replace(/[^\d]/g, '')}
                                                            />
                                                        )}
                                                    </Input.Group>
                                                </FormItem>
                                            </Col>
                                            <Col span={4}>
                                                <FormItem
                                                    label="תאריך לחיפוש"
                                                    labelCol={{ style: { textAlign: 'right' } }}
                                                >
                                                    {getFieldDecorator('dateType', {
                                                        initialValue: 'create_date'
                                                    })(
                                                        <Select style={{ width: '100%' }}>
                                                            <Select.Option value="create_date">
                                                                תאריך יצירה
                                                            </Select.Option>
                                                            <Select.Option value="first_charge_date">
                                                                תאריך חיוב ראשון
                                                            </Select.Option>
                                                            <Select.Option value="last_charge_date">
                                                                תאריך חיוב אחרון
                                                            </Select.Option>
                                                            <Select.Option value="next_charge_date">
                                                                תאריך חיוב הבא
                                                            </Select.Option>
                                                        </Select>
                                                    )}
                                                </FormItem>
                                            </Col>
                                            <Col span={6}>
                                                <FormItem
                                                    label="טווח תאריכים"
                                                    labelCol={{ style: { textAlign: 'right' } }}
                                                >
                                                    {getFieldDecorator('dateRange')(
                                                        <DatePicker.RangePicker
                                                            style={{ width: '100%', direction: 'rtl' }}
                                                            format="DD/MM/YYYY"
                                                        />
                                                    )}
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </Panel>
                                </Collapse>
                            </Col>
                            <Col span={24}>
                                <Button type="primary" htmlType="submit" loading={loading} disabled={loading}>
                                    חיפוש
                                </Button>
                                <Button onClick={resetSearch}>איפוס</Button>
                            </Col>
                        </Row>
                    </Form>
                    <Row style={{ padding: 'unset' }}>
                        {loading ? (
                            <div style={{ textAlign: 'center', padding: 40 }}>
                                <Icon type="loading" style={{ fontSize: 24 }} spin />
                            </div>
                        ) : error ? (
                            <div style={{ color: 'red', textAlign: 'center', padding: 20 }}>{error}</div>
                        ) : (
                            <Table
                                rowKey="sto_id"
                                dataSource={data}
                                scroll={{ x: 'max-content' }}
                                bordered={true}
                                // components={components}
                                // columns={columns.filter(col => !col.hidden)}
                                components={components()}
                                columns={resizableColumns}
                                locale={{ emptyText: 'לא נמצאו פרטים' }}
                                pagination={{ pageSize: 10 }}
                                style={{ padding: 'unset' }}
                                className={tableClass}
                            />
                        )}
                        {loading ? null : (
                            <Col span={24}>
                                <Button onClick={resetColumnWidths}>איפוס רוחב עמודות</Button>
                            </Col>
                        )}
                    </Row>
                </PageHeader>
            </Layout>
        )
    }
}

const statuses = {
    active: { title: 'פעיל', color: '#4caf50', type: 'check-circle' },
    inactive: { title: 'לא פעיל', color: '#f44336', type: 'close-circle' },
    error: { title: '-', color: '#f44336', type: 'close-circle' }
}

const sto_id_status = {
    exist: { title: 'קיים', color: '#4caf50', type: 'check-circle' },
    notExist: { title: 'לא קיים', color: '#f44336', type: 'close-circle' }
}

const terminals = {
    mediwho1tok: 'אשראי',
    mediwhobk: 'הו״ק',
    mediwhotok: 'אשראי (מסוף ישן)'
    // ISHPUZPLUS-PENDING: terminal not yet in Tranzila
    // ishpuzplus: 'אשראי (מסוף אשפוז)'
}

const statusOptions = [
    { label: 'פעיל', value: 'active' },
    { label: 'לא פעיל', value: 'inactive' },
    { label: 'כל הסטטוסים', value: '' }
]

const terminalOptions = [
    { label: 'הו״ק', value: 'mediwhobk' },
    { label: 'אשראי', value: 'mediwho1tok' },
    { label: 'אשראי (מסוף ישן)', value: 'mediwhotok' }
    // ISHPUZPLUS-PENDING: terminal not yet in Tranzila
    // { label: 'אשראי (מסוף אשפוז)', value: 'ishpuzplus' }
]

export default withRouter(Form.create()(SearchStoData))
